function getWindow() {
    return typeof window !== 'undefined' ? window : null;
}
let singletonConfig = null;
export function setMicroFrontToolsConfig(config) {
    const win = getWindow();
    if (win) {
        win.microFrontToolsConfig = {
            ...config,
        };
    }
    else {
        singletonConfig = {
            ...config,
        };
    }
}
function getMicroFrontToolsConfig() {
    const win = getWindow();
    if (win) {
        return win.microFrontToolsConfig;
    }
    else if (singletonConfig) {
        return singletonConfig;
    }
    return null;
}
export function getMicroFrontList() {
    return getMicroFrontToolsConfig()?.MICRO_FRONT_LIST || {};
}
export function getMessagesEventBus() {
    return getMicroFrontToolsConfig()?.MESSAGES_EVENT_BUS || {};
}
//# sourceMappingURL=settings.js.map